// extracted by mini-css-extract-plugin
export default {"patientstab":"appointment_patientstab__r+Zor"};